import axios from "axios";
// axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
// axios.defaults.headers["crossDomain"] = true;
// axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
import { env } from "../../../enums";

export default {
  state: {
    profileInfo: {
      phone: "",
      email: "",
      fullname: "",
      melicode: "",
      store_name: ""
    },
    auth: {
      routineLevel: "AUTH",
      codeWrong: false,
      token: null
    },
    isNew: false,
    error: false,
    success: "",
    addresses: [],
    location: {
      provinces: [],
      cities: []
    }
  },
  getters: {
    getAddresses(state) {
      return state.addresses;
    },
    getLocations(state) {
      return state.location;
    },
    getProfileInfo(state) {
      return state.profileInfo;
    }
  },
  mutations: {
    setProvinceList(state, data) {
      state.location.provinces = data;
    },
    setCityList(state, data) {
      state.location.cities = data;
    },
    logoutAction(state) {
      localStorage.removeItem("token");
      state.auth.token = null;
    },
    setAddresses(state, addresses) {
      state.addresses = addresses;
    },
    setCodeWrong(state, message) {
      state.error = message;
    },
    setSuccessEvent(state, message) {
      state.success = message;
    },
    setProfilePhone(state, phone) {
      state.profileInfo.phone = phone;
    },
    setProfileInfo(state, data) {
      state.profileInfo.email = data.email;
      state.profileInfo.fullname = data.fullname;
      state.profileInfo.melicode = data.melicode;
      state.profileInfo.phone = data.phone;
      state.profileInfo.store_name = data.store_name;
    }
  },
  actions: {
    setProfileQuickAccess(context) {
      context.commit("changeProfileQuickAccess");
    },
    logout(context) {
      context.commit("logoutAction");
      return new Promise(function(resolve) {
        resolve();
      });
    },
    // checkVerifyCode(context, {phone, code}) {
    //     return new Promise(() => {
    //         axios
    //             .post(env.base_url + "/auth/verify", {
    //                 phone,
    //                 code
    //             })
    //             .then(result => {
    //                 if (result.status === 200) {
    //                     localStorage.setItem("token", result.data.token);
    //                     context.commit("setAuthRoutineLevel", {
    //                         status: "WELCOME",
    //                         token: result.data.token
    //                     });
    //                     context.commit("setCodeWrong", false);

    //                     //sync basket localstorage and database
    //                     if (localStorage.getItem("basket") &&
    //                         JSON.parse(localStorage.getItem("basket")).length > 0) {
    //                         //send data and get basket
    //                         let products = JSON.parse(localStorage.getItem("basket"));
    //                         axios
    //                             .post(
    //                                 env.base_url + "/cart/update-group",
    //                                 {
    //                                     products
    //                                 },
    //                                 {
    //                                     headers: {
    //                                         Authorization: `Bearer ${localStorage.getItem("token")}`
    //                                     }
    //                                 }
    //                             )
    //                             .then(result => {
    //                                 if (result.status === 200) {
    //                                     let products = result.data.items;
    //                                     for (var i = 0; i < products.length; i++) {
    //                                         context.dispatch("addProductToBasket", {
    //                                             product: products[i]
    //                                         });
    //                                     }
    //                                 }
    //                                 //empty local storage
    //                                 localStorage.setItem("basket", "");
    //                             });
    //                     } else {
    //                         //just get baskets
    //                         axios
    //                             .get(env.base_url + "/basket/get", {
    //                                 headers: {
    //                                     Authorization: `Bearer ${localStorage.getItem("token")}`
    //                                 }
    //                             })
    //                             .then(result => {
    //                                 if (result.status === 200) {
    //                                     let products = result.data.items;
    //                                     for (var i = 0; i < products.length; i++) {
    //                                         context.dispatch("addProductToBasket", {
    //                                             product: products[i]
    //                                         });
    //                                     }
    //                                 }
    //                             });
    //                     }
    //                 }
    //             })
    //             .catch(() => {
    //                 context.commit("setCodeWrong", "کد وارد شده اشتباه است!");
    //             });
    //     });
    // },
    getProfile() {
      return new Promise(function(resolve, reject) {
        axios
          .get(env.base_url + "/account/profile", {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          })
          .then(result => {
            if (result.status == 200) {
              resolve(result.data.item);
            }
            reject({});
          })
          .catch(error => {
            if (error.response.status === 401) {
              resolve(error.response.status);
            }
          });
      });
    },
    getProfileX(context) {
      axios
        .get(env.base_url + "/account/profile", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        })
        .then(result => {
          if (result.status === 200) {
            context.commit("setProfileInfo", result.data.item);
          }
        });
    },
    getFavorite() {
      return new Promise(resolve => {
        axios
          .get(env.base_url + "/account/profile/favorites", {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          })
          .then(result => {
            return resolve(result.data);
          })
          .catch(() => {
            return resolve([]);
          });
      });
    },
    getComments() {
      return new Promise(function(resolve) {
        axios
          .get(env.base_url + "/account/profile/comments", {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          })
          .then(result => {
            resolve(result.data.items);
          });
      });
    },
    getAddresses() {
      return new Promise(function(resolve, reject) {
        axios
          .get(env.base_url + "/account/profile/addresses", {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          })
          .then(result => {
            if (result.status === 200) {
              resolve(result.data.item);
            }
            reject([]);
          });
      });
    },
    getShipping() {
      return new Promise(function(resolve, reject) {
        axios.get(env.base_url + "/shipping").then(result => {
          if (result.status === 200) {
            resolve(result.data.items);
          }
          reject([]);
        });
      });
    },
    getProvince(context) {
      return new Promise(function(resolve) {
        axios
          .get(env.base_url + "/location/province")
          .then(result => {
            if (result.status === 200) {
              context.commit("setProvinceList", result.data.item);
              resolve(result.data.item);
            } else {
              resolve(false);
            }
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
    getCity(context, { province }) {
      return new Promise(function(resolve) {
        axios
          .get(env.base_url + "/location/city?parent_id=" + province)
          .then(result => {
            if (result.status === 200) {
              context.commit("setCityList", result.data.item);
              resolve(result.data.item);
            } else {
              resolve(false);
            }
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
    saveProfileInfo(
      context,
      { fullname, melicode, shaba, phone, email, store_name }
    ) {
      return new Promise(function(resolve) {
        axios
          .post(
            env.base_url + "/account/profile",
            {
              fullname,
              melicode,
              shaba,
              phone,
              email,
              store_name
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
              }
            }
          )
          .then(result => {
            if (result.status === 200) {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
    saveAddress(context, { data }) {
      return new Promise(function(resolve, reject) {
        axios
          .post(
            env.base_url + "/account/profile/address/add",
            {
              ...data
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
              }
            }
          )
          .then(result => {
            if (result.status === 200) {
              resolve({
                success: true
              });
            } else {
              reject({
                success: false
              });
            }
          });
      });
    },
    deleteAddress(context, { id }) {
      return new Promise(function(resolve, reject) {
        axios
          .delete(env.base_url + "/account/profile/address/" + id, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          })
          .then(result => {
            if (result.status === 200) {
              resolve({
                success: true
              });
            } else {
              reject({
                success: false
              });
            }
          });
      });
    },
    saveContact(context, { data }) {
      return new Promise(function(resolve, reject) {
        axios
          .post(env.base_url + "/feedback/contact", {
            ...data
          })
          .then(result => {
            if (result.status === 200) {
              resolve({
                success: true
              });
            } else {
              reject({
                success: false
              });
            }
          });
      });
    },
    subscribe_newsletter(context, { email }) {
      return new Promise(function(resolve) {
        axios
          .post(
            env.base_url + "/newsletter/register",
            {
              email
            },
            {}
          )
          .then(() => {
            return resolve(true);
          })
          .catch(() => {
            return resolve(false);
          });
      });
    },
    changePassword(context, { password }) {
      return new Promise(resolve => {
        axios
          .post(
            env.base_url + "/account/profile/password",
            {
              password
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
              }
            }
          )
          .then(result => {
            if (result.status === 200) {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
    getProductRequests(context, { page }) {
      return new Promise(resolve => {
        axios
          .get(
            env.base_url + `/request-products${page ? "?page=" + page : ""}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
              }
            }
          )
          .then(result => {
            return resolve(result.data);
          });
      });
    }
  }
};
